import { _ as e } from "./tslib.es6-7f1b1220.js";
import { d as t, N as i, T as r, e as o, r as n, c as s, u as a, h as l, n as u } from "./lit-element-161a1699.js";
import { p as c, a as p, q as h, s as d, e as f, c as v } from "./decorators-7e9cd43b.js";
import "./class-map-31af68b2.js";
import { RealBaseElement as m } from "./BaseElement.esm.min.js";
import { h as _ } from "./host.styles-cf05db22.js";
import { e as b } from "./event.decorator-98549cbc.js";
import { i as y } from "./if-defined-123567fc.js";
import "./types-814d68fb.js";
import { deprecatedListWrapperConverter as g, getStringArrayConverter as j, commaListConverter as w } from "./component.utils.esm.min.js";
import "./mixin.utils.esm.min.js";
import { F as z } from "./form-data-handling.mixin-3ddec2ca.js";
import "./dom.utils.esm.min.js";
import { F as O } from "./form-validation.mixin-0a6c3c34.js";
import { s as $ } from "./style-map-a37d7105.js";
import { generateUid as S, getContentsFromPortal as E } from "./portal.utils.esm.min.js";
import "./error-message.component.esm.min.js";
import { u as x } from "./unsafe-html-97738913.js";
import { SelectDivider as A } from "./select-divider.component.esm.min.js";
import { SelectOption as C } from "./select-option.component.esm.min.js";
import "./select-all.component.esm.min.js";
import "./select-menu.component.esm.min.js";
import "./select-placeholder.component.esm.min.js";
import { a as M, b as R, r as k, i as B, f as I, S as P } from "./isObject-07b7923e.js";
/**
 * @license
 * Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
const F = new WeakMap(),
  D = t(e => t => {
    if (!(t instanceof i)) throw new Error("cache can only be used in text bindings");
    let s = F.get(t);
    void 0 === s && (s = new WeakMap(), F.set(t, s));
    const a = t.value;
    if (a instanceof r) {
      if (e instanceof o && a.template === t.options.templateFactory(e)) return void t.setValue(e);
      {
        let e = s.get(a.template);
        void 0 === e && (e = {
          instance: a,
          nodes: document.createDocumentFragment()
        }, s.set(a.template, e)), n(e.nodes, t.startNode.nextSibling, t.endNode);
      }
    }
    if (e instanceof o) {
      const i = t.options.templateFactory(e),
        r = s.get(i);
      void 0 !== r && (t.setValue(r.nodes), t.commit(), t.value = r.instance);
    }
    t.setValue(e);
  });
var L = Array.isArray;
function V(e) {
  if (!M(e)) return !1;
  var t = R(e);
  return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
}
var T,
  W = k["__core-js_shared__"],
  q = (T = /[^.]+$/.exec(W && W.keys && W.keys.IE_PROTO || "")) ? "Symbol(src)_1." + T : "";
var N = Function.prototype.toString;
function U(e) {
  if (null != e) {
    try {
      return N.call(e);
    } catch (e) {}
    try {
      return e + "";
    } catch (e) {}
  }
  return "";
}
var H = /^\[object .+?Constructor\]$/,
  K = Function.prototype,
  G = Object.prototype,
  Q = K.toString,
  J = G.hasOwnProperty,
  X = RegExp("^" + Q.call(J).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function Y(e) {
  return !(!M(e) || (t = e, q && q in t)) && (V(e) ? X : H).test(U(e));
  var t;
}
function Z(e, t) {
  var i = function (e, t) {
    return null == e ? void 0 : e[t];
  }(e, t);
  return Y(i) ? i : void 0;
}
var ee = Z(k, "WeakMap"),
  te = /^(?:0|[1-9]\d*)$/;
function ie(e, t) {
  var i = typeof e;
  return !!(t = null == t ? 9007199254740991 : t) && ("number" == i || "symbol" != i && te.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function re(e, t) {
  return e === t || e != e && t != t;
}
function oe(e) {
  return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
}
var ne = Object.prototype;
function se(e) {
  return B(e) && "[object Arguments]" == R(e);
}
var ae = Object.prototype,
  le = ae.hasOwnProperty,
  ue = ae.propertyIsEnumerable,
  ce = se(function () {
    return arguments;
  }()) ? se : function (e) {
    return B(e) && le.call(e, "callee") && !ue.call(e, "callee");
  };
var pe = "object" == typeof exports && exports && !exports.nodeType && exports,
  he = pe && "object" == typeof module && module && !module.nodeType && module,
  de = he && he.exports === pe ? k.Buffer : void 0,
  fe = (de ? de.isBuffer : void 0) || function () {
    return !1;
  },
  ve = {};
ve["[object Float32Array]"] = ve["[object Float64Array]"] = ve["[object Int8Array]"] = ve["[object Int16Array]"] = ve["[object Int32Array]"] = ve["[object Uint8Array]"] = ve["[object Uint8ClampedArray]"] = ve["[object Uint16Array]"] = ve["[object Uint32Array]"] = !0, ve["[object Arguments]"] = ve["[object Array]"] = ve["[object ArrayBuffer]"] = ve["[object Boolean]"] = ve["[object DataView]"] = ve["[object Date]"] = ve["[object Error]"] = ve["[object Function]"] = ve["[object Map]"] = ve["[object Number]"] = ve["[object Object]"] = ve["[object RegExp]"] = ve["[object Set]"] = ve["[object String]"] = ve["[object WeakMap]"] = !1;
var me,
  _e = "object" == typeof exports && exports && !exports.nodeType && exports,
  be = _e && "object" == typeof module && module && !module.nodeType && module,
  ye = be && be.exports === _e && I.process,
  ge = function () {
    try {
      var e = be && be.require && be.require("util").types;
      return e || ye && ye.binding && ye.binding("util");
    } catch (e) {}
  }(),
  je = ge && ge.isTypedArray,
  we = je ? (me = je, function (e) {
    return me(e);
  }) : function (e) {
    return B(e) && oe(e.length) && !!ve[R(e)];
  },
  ze = Object.prototype.hasOwnProperty;
function Oe(e, t) {
  var i = L(e),
    r = !i && ce(e),
    o = !i && !r && fe(e),
    n = !i && !r && !o && we(e),
    s = i || r || o || n,
    a = s ? function (e, t) {
      for (var i = -1, r = Array(e); ++i < e;) r[i] = t(i);
      return r;
    }(e.length, String) : [],
    l = a.length;
  for (var u in e) !t && !ze.call(e, u) || s && ("length" == u || o && ("offset" == u || "parent" == u) || n && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || ie(u, l)) || a.push(u);
  return a;
}
var $e = function (e, t) {
    return function (i) {
      return e(t(i));
    };
  }(Object.keys, Object),
  Se = Object.prototype.hasOwnProperty;
function Ee(e) {
  if (i = (t = e) && t.constructor, t !== ("function" == typeof i && i.prototype || ne)) return $e(e);
  var t,
    i,
    r = [];
  for (var o in Object(e)) Se.call(e, o) && "constructor" != o && r.push(o);
  return r;
}
function xe(e) {
  return null != (t = e) && oe(t.length) && !V(t) ? Oe(e) : Ee(e);
  var t;
}
var Ae = Z(Object, "create");
var Ce = Object.prototype.hasOwnProperty;
var Me = Object.prototype.hasOwnProperty;
function Re(e) {
  var t = -1,
    i = null == e ? 0 : e.length;
  for (this.clear(); ++t < i;) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
function ke(e, t) {
  for (var i = e.length; i--;) if (re(e[i][0], t)) return i;
  return -1;
}
Re.prototype.clear = function () {
  this.__data__ = Ae ? Ae(null) : {}, this.size = 0;
}, Re.prototype.delete = function (e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}, Re.prototype.get = function (e) {
  var t = this.__data__;
  if (Ae) {
    var i = t[e];
    return "__lodash_hash_undefined__" === i ? void 0 : i;
  }
  return Ce.call(t, e) ? t[e] : void 0;
}, Re.prototype.has = function (e) {
  var t = this.__data__;
  return Ae ? void 0 !== t[e] : Me.call(t, e);
}, Re.prototype.set = function (e, t) {
  var i = this.__data__;
  return this.size += this.has(e) ? 0 : 1, i[e] = Ae && void 0 === t ? "__lodash_hash_undefined__" : t, this;
};
var Be = Array.prototype.splice;
function Ie(e) {
  var t = -1,
    i = null == e ? 0 : e.length;
  for (this.clear(); ++t < i;) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Ie.prototype.clear = function () {
  this.__data__ = [], this.size = 0;
}, Ie.prototype.delete = function (e) {
  var t = this.__data__,
    i = ke(t, e);
  return !(i < 0) && (i == t.length - 1 ? t.pop() : Be.call(t, i, 1), --this.size, !0);
}, Ie.prototype.get = function (e) {
  var t = this.__data__,
    i = ke(t, e);
  return i < 0 ? void 0 : t[i][1];
}, Ie.prototype.has = function (e) {
  return ke(this.__data__, e) > -1;
}, Ie.prototype.set = function (e, t) {
  var i = this.__data__,
    r = ke(i, e);
  return r < 0 ? (++this.size, i.push([e, t])) : i[r][1] = t, this;
};
var Pe = Z(k, "Map");
function Fe(e, t) {
  var i,
    r,
    o = e.__data__;
  return ("string" == (r = typeof (i = t)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== i : null === i) ? o["string" == typeof t ? "string" : "hash"] : o.map;
}
function De(e) {
  var t = -1,
    i = null == e ? 0 : e.length;
  for (this.clear(); ++t < i;) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
De.prototype.clear = function () {
  this.size = 0, this.__data__ = {
    hash: new Re(),
    map: new (Pe || Ie)(),
    string: new Re()
  };
}, De.prototype.delete = function (e) {
  var t = Fe(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}, De.prototype.get = function (e) {
  return Fe(this, e).get(e);
}, De.prototype.has = function (e) {
  return Fe(this, e).has(e);
}, De.prototype.set = function (e, t) {
  var i = Fe(this, e),
    r = i.size;
  return i.set(e, t), this.size += i.size == r ? 0 : 1, this;
};
function Le(e) {
  var t = this.__data__ = new Ie(e);
  this.size = t.size;
}
Le.prototype.clear = function () {
  this.__data__ = new Ie(), this.size = 0;
}, Le.prototype.delete = function (e) {
  var t = this.__data__,
    i = t.delete(e);
  return this.size = t.size, i;
}, Le.prototype.get = function (e) {
  return this.__data__.get(e);
}, Le.prototype.has = function (e) {
  return this.__data__.has(e);
}, Le.prototype.set = function (e, t) {
  var i = this.__data__;
  if (i instanceof Ie) {
    var r = i.__data__;
    if (!Pe || r.length < 199) return r.push([e, t]), this.size = ++i.size, this;
    i = this.__data__ = new De(r);
  }
  return i.set(e, t), this.size = i.size, this;
};
var Ve = Object.prototype.propertyIsEnumerable,
  Te = Object.getOwnPropertySymbols,
  We = Te ? function (e) {
    return null == e ? [] : (e = Object(e), function (e, t) {
      for (var i = -1, r = null == e ? 0 : e.length, o = 0, n = []; ++i < r;) {
        var s = e[i];
        t(s, i, e) && (n[o++] = s);
      }
      return n;
    }(Te(e), function (t) {
      return Ve.call(e, t);
    }));
  } : function () {
    return [];
  };
function qe(e) {
  return function (e, t, i) {
    var r = t(e);
    return L(e) ? r : function (e, t) {
      for (var i = -1, r = t.length, o = e.length; ++i < r;) e[o + i] = t[i];
      return e;
    }(r, i(e));
  }(e, xe, We);
}
var Ne = Z(k, "DataView"),
  Ue = Z(k, "Promise"),
  He = Z(k, "Set"),
  Ke = U(Ne),
  Ge = U(Pe),
  Qe = U(Ue),
  Je = U(He),
  Xe = U(ee),
  Ye = R;
(Ne && "[object DataView]" != Ye(new Ne(new ArrayBuffer(1))) || Pe && "[object Map]" != Ye(new Pe()) || Ue && "[object Promise]" != Ye(Ue.resolve()) || He && "[object Set]" != Ye(new He()) || ee && "[object WeakMap]" != Ye(new ee())) && (Ye = function (e) {
  var t = R(e),
    i = "[object Object]" == t ? e.constructor : void 0,
    r = i ? U(i) : "";
  if (r) switch (r) {
    case Ke:
      return "[object DataView]";
    case Ge:
      return "[object Map]";
    case Qe:
      return "[object Promise]";
    case Je:
      return "[object Set]";
    case Xe:
      return "[object WeakMap]";
  }
  return t;
});
var Ze = Ye,
  et = k.Uint8Array;
function tt(e) {
  var t = -1,
    i = null == e ? 0 : e.length;
  for (this.__data__ = new De(); ++t < i;) this.add(e[t]);
}
function it(e, t) {
  for (var i = -1, r = null == e ? 0 : e.length; ++i < r;) if (t(e[i], i, e)) return !0;
  return !1;
}
function rt(e, t) {
  return e.has(t);
}
tt.prototype.add = tt.prototype.push = function (e) {
  return this.__data__.set(e, "__lodash_hash_undefined__"), this;
}, tt.prototype.has = function (e) {
  return this.__data__.has(e);
};
function ot(e, t, i, r, o, n) {
  var s = 1 & i,
    a = e.length,
    l = t.length;
  if (a != l && !(s && l > a)) return !1;
  var u = n.get(e),
    c = n.get(t);
  if (u && c) return u == t && c == e;
  var p = -1,
    h = !0,
    d = 2 & i ? new tt() : void 0;
  for (n.set(e, t), n.set(t, e); ++p < a;) {
    var f = e[p],
      v = t[p];
    if (r) var m = s ? r(v, f, p, t, e, n) : r(f, v, p, e, t, n);
    if (void 0 !== m) {
      if (m) continue;
      h = !1;
      break;
    }
    if (d) {
      if (!it(t, function (e, t) {
        if (!rt(d, t) && (f === e || o(f, e, i, r, n))) return d.push(t);
      })) {
        h = !1;
        break;
      }
    } else if (f !== v && !o(f, v, i, r, n)) {
      h = !1;
      break;
    }
  }
  return n.delete(e), n.delete(t), h;
}
function nt(e) {
  var t = -1,
    i = Array(e.size);
  return e.forEach(function (e, r) {
    i[++t] = [r, e];
  }), i;
}
function st(e) {
  var t = -1,
    i = Array(e.size);
  return e.forEach(function (e) {
    i[++t] = e;
  }), i;
}
var at = P ? P.prototype : void 0,
  lt = at ? at.valueOf : void 0;
var ut = Object.prototype.hasOwnProperty;
var ct = Object.prototype.hasOwnProperty;
function pt(e, t, i, r, o, n) {
  var s = L(e),
    a = L(t),
    l = s ? "[object Array]" : Ze(e),
    u = a ? "[object Array]" : Ze(t),
    c = "[object Object]" == (l = "[object Arguments]" == l ? "[object Object]" : l),
    p = "[object Object]" == (u = "[object Arguments]" == u ? "[object Object]" : u),
    h = l == u;
  if (h && fe(e)) {
    if (!fe(t)) return !1;
    s = !0, c = !1;
  }
  if (h && !c) return n || (n = new Le()), s || we(e) ? ot(e, t, i, r, o, n) : function (e, t, i, r, o, n, s) {
    switch (i) {
      case "[object DataView]":
        if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
        e = e.buffer, t = t.buffer;
      case "[object ArrayBuffer]":
        return !(e.byteLength != t.byteLength || !n(new et(e), new et(t)));
      case "[object Boolean]":
      case "[object Date]":
      case "[object Number]":
        return re(+e, +t);
      case "[object Error]":
        return e.name == t.name && e.message == t.message;
      case "[object RegExp]":
      case "[object String]":
        return e == t + "";
      case "[object Map]":
        var a = nt;
      case "[object Set]":
        var l = 1 & r;
        if (a || (a = st), e.size != t.size && !l) return !1;
        var u = s.get(e);
        if (u) return u == t;
        r |= 2, s.set(e, t);
        var c = ot(a(e), a(t), r, o, n, s);
        return s.delete(e), c;
      case "[object Symbol]":
        if (lt) return lt.call(e) == lt.call(t);
    }
    return !1;
  }(e, t, l, i, r, o, n);
  if (!(1 & i)) {
    var d = c && ct.call(e, "__wrapped__"),
      f = p && ct.call(t, "__wrapped__");
    if (d || f) {
      var v = d ? e.value() : e,
        m = f ? t.value() : t;
      return n || (n = new Le()), o(v, m, i, r, n);
    }
  }
  return !!h && (n || (n = new Le()), function (e, t, i, r, o, n) {
    var s = 1 & i,
      a = qe(e),
      l = a.length;
    if (l != qe(t).length && !s) return !1;
    for (var u = l; u--;) {
      var c = a[u];
      if (!(s ? c in t : ut.call(t, c))) return !1;
    }
    var p = n.get(e),
      h = n.get(t);
    if (p && h) return p == t && h == e;
    var d = !0;
    n.set(e, t), n.set(t, e);
    for (var f = s; ++u < l;) {
      var v = e[c = a[u]],
        m = t[c];
      if (r) var _ = s ? r(m, v, c, t, e, n) : r(v, m, c, e, t, n);
      if (!(void 0 === _ ? v === m || o(v, m, i, r, n) : _)) {
        d = !1;
        break;
      }
      f || (f = "constructor" == c);
    }
    if (d && !f) {
      var b = e.constructor,
        y = t.constructor;
      b == y || !("constructor" in e) || !("constructor" in t) || "function" == typeof b && b instanceof b && "function" == typeof y && y instanceof y || (d = !1);
    }
    return n.delete(e), n.delete(t), d;
  }(e, t, i, r, o, n));
}
function ht(e, t, i, r, o) {
  return e === t || (null == e || null == t || !B(e) && !B(t) ? e != e && t != t : pt(e, t, i, r, ht, o));
}
var dt;
const ft = ["bottom-start", "bottom-end", "top-start", "top-end"],
  vt = s`${a(":host {\n  --zui-select-animation-duration: 0.1s;\n  --zui-select-width: calc(var(--zui-gu) * 15);\n  display: inline-block;\n  position: relative;\n  width: var(--zui-select-width);\n  text-align: left;\n}\n\n.trap {\n  display: none;\n}")}`;
let mt = dt = class extends O(z(m)) {
  constructor() {
    super(), this.ariaHaspopup = "listbox", this.ariaExpanded = "false", this.role = "listbox", this.emphasis = "selected", this.hideBorder = !1, this.ignoreOutsideClick = !1, this.placeholder = "", this.portal = `select-${S()}`, this.size = this.hasTouch ? "l" : "s", this.alternative = !1, this.expanded = !1, this.multiple = !1, this.showAllItem = !1, this.allItemLabel = "All", this.adaptMenuWidth = !1, this.menuOverflow = "truncate", this.menuPlacements = ft, this.required = !1, this.value = [], this._opened = this.expanded, this.getPositionReference = () => this._buttonRef, this.addValidator({
      validator: () => {
        var e;
        return !1 === this.required || (null === (e = this.value) || void 0 === e ? void 0 : e.length) > 0;
      },
      type: "valueMissing",
      validatesOnProperties: ["required"]
    }), this.setDefaultValidityMessages({
      valueMissing: dt.REQUIRED_ERROR_MESSAGE
    });
  }
  emitChangeEvent() {
    this.dispatchEvent(new Event("change", {
      bubbles: !0,
      composed: !1
    }));
  }
  emitInputEvent() {
    this.dispatchEvent(new Event("input", {
      bubbles: !0,
      composed: !1
    }));
  }
  emitOpenEvent() {
    this.dispatchEvent(new CustomEvent("open", {
      bubbles: !0,
      composed: !1
    }));
  }
  emitCloseEvent() {
    this.dispatchEvent(new CustomEvent("close", {
      bubbles: !0,
      composed: !1
    }));
  }
  get _selectOptions() {
    var e;
    return null === (e = this._optionRefs) || void 0 === e ? void 0 : e.filter(e => "zui-select-option" === e.tagName.toLowerCase());
  }
  _handleBlur(e) {
    var t, i;
    const r = e.relatedTarget,
      o = this.isSameNode(r),
      n = this.contains(r),
      s = "zui-portal" === (null == r ? void 0 : r.tagName.toLowerCase()),
      a = null === (t = this._selectMenuRef) || void 0 === t ? void 0 : t.isSameNode(r),
      l = null === (i = this._selectMenuRef) || void 0 === i ? void 0 : i.contains(r);
    o || n || s || a || l || this._toggleMenu(!1);
  }
  _handleButtonClick() {
    this.disabled || this.readonly || this._toggleMenu();
  }
  _handleItemClick({
    currentTarget: e
  }) {
    this.disabled || e.disabled || (this.multiple ? this._selectMultiple(e.value) : this._selectSingle(e.value), this._updateAllItemState());
  }
  _handleAllClick() {
    var e;
    !0 !== this.disabled && this._selectAll(this._selectCount !== (null === (e = this._selectOptions) || void 0 === e ? void 0 : e.filter(({
      disabled: e
    }) => !e).length));
  }
  _handleDefaultSlotChange() {
    this.value = this._enabledOptionRefs.filter(e => e.selected).map(({
      value: e
    }) => e);
  }
  get _selectCount() {
    return void 0 === this.value ? 0 : this.value.length;
  }
  get _hasSelection() {
    return this._selectCount > 0;
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("blur", this._handleBlur), this.addEventListener("focus", this._handleFocus);
  }
  disconnectedCallback() {
    this.removeEventListener("blur", this._handleBlur), this.removeEventListener("focus", this._handleFocus), super.disconnectedCallback();
  }
  _reflectValueToOptions() {
    this._enabledOptionRefs.forEach(e => {
      e.selected = this._hasSelection && this.value.includes(e.value);
    }), this.requestUpdate();
  }
  _selectAll(e) {
    this.value = e ? this._enabledOptionRefs.map(({
      value: e
    }) => e) : [], this.emitChangeEvent(), this.emitInputEvent(), this._updateAllItemState();
  }
  _toggleMenu(e = !this.expanded) {
    this._opened !== e && (e ? (this.expanded = !0, this._opened = !0) : this._opened = !1);
  }
  _updateRefs() {
    requestAnimationFrame(() => {
      var e;
      const [t] = E(this.portal, "zui-select-menu"),
        [i] = E(this.portal, "zui-menu");
      this._selectMenuRef = t, this._updateAllItemState(), null === (e = this._overlayRef) || void 0 === e || e.forcePositioning(), null == i || i.focus();
    });
  }
  _removeMenu() {
    var e;
    this.expanded = !1, null === (e = this._buttonRef) || void 0 === e || e.focus();
  }
  _injectCustomProperties() {
    const e = getComputedStyle(this);
    return ["--zui-select-animation-duration", "--zui-select-width"].reduce((t, i) => Object.assign(Object.assign({}, t), {
      [i]: e.getPropertyValue(i)
    }), {});
  }
  _updateAllItemState() {
    var e;
    this._hasSelection ? this._allItemState = !(this._selectCount < (null === (e = this._selectOptions) || void 0 === e ? void 0 : e.length)) || "mixed" : this._allItemState = !1;
  }
  _selectSingle(e) {
    this.value = "" !== e ? [e] : [], this.emitChangeEvent(), this.emitInputEvent(), this._toggleMenu(!1);
  }
  _selectMultiple(e) {
    if (this._hasSelection && this.value.includes(e)) {
      const t = this.value.indexOf(e);
      this.value = [...this.value.slice(0, t), ...this.value.slice(t + 1)];
    } else Array.isArray(this.value) ? this.value = [...this.value, e] : this.value = [e];
    this.emitChangeEvent(), this.emitInputEvent();
  }
  _handleKeysForSelectButton({
    code: e
  }) {
    if (!this.disabled) switch (e) {
      case "Enter":
      case "Space":
      case "ArrowUp":
      case "ArrowDown":
        this._toggleMenu(!0);
    }
  }
  _handleKeysForMenuItems({
    code: e
  }) {
    if ("Escape" === e) this._toggleMenu(!1);
  }
  _handleFocus() {
    var e;
    this.disabled || null === (e = this._buttonRef) || void 0 === e || e.focus();
  }
  getPlaceholder() {
    var e;
    return (null === (e = this._placeholderRefs) || void 0 === e ? void 0 : e.length) > 0 ? this._placeholderRefs[0] : this._placeholderRef;
  }
  getDisplayValueFromPlaceholder() {
    const e = this.getPlaceholder();
    return null !== e ? this._hasSelection ? e.format(this._selectOptions, this._enabledOptionRefs.filter(({
      value: e
    }) => this.value.includes(e)), this.multiple) : e.innerHTML : this.placeholder;
  }
  getMenuWidth() {
    const e = getComputedStyle(this).getPropertyValue("--zui-select-menu-width");
    return "" !== e ? e : `${this.offsetWidth}px`;
  }
  update(e) {
    super.update(e), e.has("ignoreOutsideClick") && this.ignoreOutsideClick && console.warn("Deprecated ignoreOutsideClick was used on zui-select."), e.has("emphasis") && ("active" !== this.emphasis && "active-primary" !== this.emphasis || console.warn(`Deprecated emphasis: ${this.emphasis} was used on zui-select.`)), this.ariaExpanded = String(this.expanded);
  }
  updated(e) {
    super.updated(e), e.has("value") && this._reflectValueToOptions(), e.has("expanded") && this.expanded && requestAnimationFrame(() => this._toggleMenu(!0));
  }
  render() {
    var e, t;
    return l`<slot class="trap" name="placeholder"><zui-select-placeholder slot="placeholder">${this.placeholder}</zui-select-placeholder></slot><slot class="trap" @slotchange="${this._handleDefaultSlotChange}"></slot><zui-select-button aria-describedby="menu" aria-expanded="${this.expanded ? "true" : "false"}" aria-haspopup="${(null === (e = this._selectOptions) || void 0 === e ? void 0 : e.length) ? "menu" : "false"}" role="listbox" ?alternative="${this.alternative}" ?disabled="${this.disabled}" ?hide-border="${this.hideBorder}" ?opened="${this.expanded}" ?readonly="${this.readonly}" ?selected="${this._hasSelection}" size="${this.size}" tabindex="0" @click="${this._handleButtonClick}" @keydown="${this._handleKeysForSelectButton}">${x(this.getDisplayValueFromPlaceholder())}</zui-select-button>${this.expanded ? D(l`<zui-overlay-directive flip level="${y(this.level)}" portal="${this.portal}" placements="${this.menuPlacements.toString()}" .positionReferenceCallback="${this.getPositionReference}"><zui-select-menu ?open="${this._opened}" style="${$(this._injectCustomProperties())}" @select-menu-open="${this._updateRefs}" @select-menu-closed="${this._removeMenu}"><zui-menu id="menu" scrollable-background="visible" size="${this.size}" overflow="${this.menuOverflow}" tabindex="${this.expanded ? 0 : -1}" ?adapt-width="${this.adaptMenuWidth}" ?disabled="${this.disabled}" style="${$({
      "--zui-menu-margin-top": this.hideBorder ? "4px" : "0",
      "--zui-menu-width": this.getMenuWidth()
    })}" @blur="${this._handleBlur}" @keydown="${this._handleKeysForMenuItems}">${this.multiple && this.showAllItem ? l`<zui-select-all value="${this._allItemState}" @blur="${this._handleBlur}" @click="${this._handleAllClick}">${this.allItemLabel}</zui-select-all>` : u} ${null === (t = this._optionRefs) || void 0 === t ? void 0 : t.map(e => e instanceof A ? l`<zui-menu-divider>${x(e.innerHTML)}</zui-menu-divider>` : e instanceof C ? l`<zui-menu-item role="option" emphasis="${!this.multiple && e.selected ? this.emphasis : "default"}" aria-selected="${e.selected}" ?selectable="${this.multiple}" ?selected="${e.selected}" ?disabled="${this.disabled || e.disabled}" value="${e.value}" @blur="${this._handleBlur}" @click="${this._handleItemClick}">${x(e.innerHTML)}</zui-menu-item>` : u)}</zui-menu></zui-select-menu></zui-overlay-directive>`) : u} ${this.invalid && this.willValidate ? l`<zui-error-message>${this.validationMessage}</zui-error-message>` : u}`;
  }
};
mt.styles = [_, vt], mt.REQUIRED_ERROR_MESSAGE = "Selection is required.", e([c({
  reflect: !0,
  attribute: "aria-haspopup"
})], mt.prototype, "ariaHaspopup", void 0), e([c({
  reflect: !0,
  attribute: "aria-expanded",
  type: String
})], mt.prototype, "ariaExpanded", void 0), e([c({
  reflect: !0
})], mt.prototype, "role", void 0), e([c({
  reflect: !0,
  type: String
})], mt.prototype, "emphasis", void 0), e([c({
  reflect: !0,
  type: Boolean,
  attribute: "hide-border"
})], mt.prototype, "hideBorder", void 0), e([c({
  reflect: !0,
  type: Boolean,
  attribute: "ignore-outside-click"
})], mt.prototype, "ignoreOutsideClick", void 0), e([c({
  reflect: !0,
  type: String
})], mt.prototype, "placeholder", void 0), e([c({
  reflect: !0,
  type: String
})], mt.prototype, "portal", void 0), e([c({
  reflect: !0,
  type: Number
})], mt.prototype, "level", void 0), e([c({
  reflect: !0,
  type: String
})], mt.prototype, "size", void 0), e([c({
  reflect: !0,
  type: Boolean
})], mt.prototype, "alternative", void 0), e([c({
  reflect: !0,
  type: Boolean
})], mt.prototype, "expanded", void 0), e([c({
  reflect: !0,
  type: Boolean
})], mt.prototype, "multiple", void 0), e([c({
  reflect: !0,
  type: Boolean,
  attribute: "show-all-item"
})], mt.prototype, "showAllItem", void 0), e([c({
  reflect: !0,
  type: String,
  attribute: "all-item-label"
})], mt.prototype, "allItemLabel", void 0), e([c({
  reflect: !0,
  type: Boolean,
  attribute: "adapt-menu-width"
})], mt.prototype, "adaptMenuWidth", void 0), e([c({
  reflect: !0,
  type: String,
  attribute: "menu-overflow"
})], mt.prototype, "menuOverflow", void 0), e([c({
  reflect: !0,
  converter: g(j()),
  attribute: "menu-placements"
})], mt.prototype, "menuPlacements", void 0), e([c({
  reflect: !0,
  type: Boolean
})], mt.prototype, "required", void 0), e([c({
  reflect: !0,
  type: String,
  converter: w,
  hasChanged: (e, t) => !function (e, t) {
    return ht(e, t);
  }(e, t)
})], mt.prototype, "value", void 0), e([b()], mt.prototype, "emitChangeEvent", null), e([b()], mt.prototype, "emitInputEvent", null), e([b()], mt.prototype, "emitOpenEvent", null), e([b()], mt.prototype, "emitCloseEvent", null), e([p("zui-select-button")], mt.prototype, "_buttonRef", void 0), e([h(void 0, !0, "zui-select-divider,zui-select-option")], mt.prototype, "_optionRefs", void 0), e([h(void 0, !0, "zui-select-option:not([disabled])")], mt.prototype, "_enabledOptionRefs", void 0), e([h("placeholder", !1, "zui-select-placeholder")], mt.prototype, "_placeholderRefs", void 0), e([p("zui-select-placeholder")], mt.prototype, "_placeholderRef", void 0), e([p("zui-overlay-directive")], mt.prototype, "_overlayRef", void 0), e([d()], mt.prototype, "_opened", void 0), e([d()], mt.prototype, "_allItemState", void 0), e([f({
  passive: !0
})], mt.prototype, "_handleBlur", null), e([f({
  passive: !0
})], mt.prototype, "_handleButtonClick", null), e([f({
  passive: !0
})], mt.prototype, "_handleItemClick", null), e([f({
  passive: !0
})], mt.prototype, "_handleAllClick", null), e([f({
  passive: !0
})], mt.prototype, "_handleDefaultSlotChange", null), mt = dt = e([v("zui-select")], mt);
export { mt as Select };
